/**
 * "Brief me" (screenshots/47). Generated server-side (Claude) from public records only.
 * Every claim carries source keys; the UI renders them as chips linking to the record.
 */
export interface BriefSource { key: string; label: string; href: string }
export interface BriefClaim { text: string; sources: string[] }
export interface Brief {
  id: string; recordId: string; title: string; audience: string; generatedAt: string;
  bottomLine: string;
  sections: { title: string; claims: BriefClaim[] }[];
  people: { personId: string; name: string; ward: number; photoUrl?: string | null; forecastPct: number; note: string; sources: string[] }[];
  sources: BriefSource[];
  /** Fingerprint of the inputs used (forecast %, timeline length, documents) to detect staleness. */
  inputs: { forecast: Record<string, number>; timelineSteps: number; documents: number };
}

/** Every claim must cite at least one source that exists. Run before showing or sharing. */
export function unsourcedClaims(b: Brief): string[] {
  const keys = new Set(b.sources.map((s) => s.key));
  const all = [...b.sections.flatMap((s) => s.claims), ...b.people.map((p) => ({ text: p.note, sources: p.sources }))];
  return all.filter((c) => c.sources.length === 0 || c.sources.some((k) => !keys.has(k))).map((c) => c.text);
}

/** "Kept up to date": what changed since the brief was generated (shown as a banner + Regenerate). */
export function briefChanges(b: Brief, now: Brief["inputs"], threshold = 0.05): string[] {
  const out: string[] = [];
  for (const [id, p] of Object.entries(now.forecast)) {
    const was = b.inputs.forecast[id];
    if (was !== undefined && Math.abs(p - was) >= threshold) out.push(`Forecast for ${id} moved ${Math.round((p - was) * 100)} pts`);
  }
  if (now.timelineSteps > b.inputs.timelineSteps) out.push("New step on the timeline");
  if (now.documents > b.inputs.documents) out.push("New document");
  return out;
}
